import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// Icon map for dynamic categories
export const ICON_OPTIONS = [
  { id: 'Dumbbell', name: 'Ejercicio' },
  { id: 'Brain', name: 'Cerebro' },
  { id: 'Laptop', name: 'Laptop' },
  { id: 'CandlestickChart', name: 'Trading' },
  { id: 'TrendingUp', name: 'Tendencia' },
  { id: 'Building2', name: 'Edificio' },
  { id: 'BookOpen', name: 'Libro' },
  { id: 'Heart', name: 'Corazón' },
  { id: 'Star', name: 'Estrella' },
  { id: 'Target', name: 'Objetivo' },
  { id: 'Zap', name: 'Energía' },
  { id: 'Coffee', name: 'Café' },
  { id: 'Music', name: 'Música' },
  { id: 'Palette', name: 'Arte' },
  { id: 'Briefcase', name: 'Trabajo' },
  { id: 'GraduationCap', name: 'Educación' },
  { id: 'Users', name: 'Social' },
  { id: 'Home', name: 'Hogar' },
  { id: 'Car', name: 'Vehículo' },
  { id: 'Plane', name: 'Viaje' },
  { id: 'Circle', name: 'Círculo' },
]

export const COLOR_OPTIONS = [
  '#0ea5e9', // Sky
  '#8b5cf6', // Violet
  '#10b981', // Emerald
  '#f59e0b', // Amber
  '#eab308', // Yellow
  '#14b8a6', // Teal
  '#ec4899', // Pink
  '#ef4444', // Red
  '#f97316', // Orange
  '#84cc16', // Lime
  '#06b6d4', // Cyan
  '#6366f1', // Indigo
  '#a855f7', // Purple
  '#d946ef', // Fuchsia
  '#64748b', // Slate
]

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('es-ES', {
    weekday: 'short',
    day: 'numeric',
    month: 'short'
  })
}

export const formatTime = (seconds) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = Math.floor(seconds % 60)
  
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
}

export const formatHours = (hours) => {
  const h = Math.floor(hours)
  const m = Math.round((hours - h) * 60)
  return `${h}h ${m}m`
}

export const getTodayDate = () => {
  // Get today's date in local timezone (YYYY-MM-DD format)
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const getDateRange = (days) => {
  const end = new Date()
  const start = new Date()
  start.setDate(start.getDate() - days)
  
  return {
    start: start.toISOString().split('T')[0],
    end: end.toISOString().split('T')[0]
  }
}
